import { ImageViewerModal } from "@common/camera/CameraImagesM"
import AvatarM from "@common/components/avatar/AvatarM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { IconImageM } from "@common/components/icons/IconsM"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { useCamera } from "@common/hooks/useCamera"
import MediaPreviewModal from "@common/messenger/MediaPreviewModal"
import GenerateActivityModal from "../../tutor/students/GenerateActivityModal"
import { theme } from "@common/theme/theme"
import { notifyBugsnag } from "@common/utils/initBugsnag"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    changeCount,
    changeUnreadMessageInLiveCount,
} from "@data/redux/actions/broadcast"
import { studentsService } from "@data/services/studentsService"
import { useNavigation } from "@react-navigation/native"
import fr from "dayjs/locale/fr"
import * as Clipboard from "expo-clipboard"
import * as DocumentPicker from "expo-document-picker"
import * as ImagePicker from "expo-image-picker"
import * as Notifications from "expo-notifications"
import { StatusBar } from "@common/systemBars/StatusBar"
import { decode } from "html-entities"
import moment from "moment"
import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import {
    AppState,
    KeyboardAvoidingView,
    Platform,
    Pressable,
    View,
} from "react-native"
import {
    Bubble,
    Composer,
    GiftedChat,
    InputToolbar,
    LoadEarlier,
    Message,
    Send,
} from "react-native-gifted-chat"
import TypingIndicator from "react-native-gifted-chat/lib/TypingIndicator"
import { ActivityIndicator } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { API_URL, cleanMediaUrl } from "../../data/constants/apiConstants"
import { clearLastPhoto, setLastPhoto } from "../../data/redux/actions/camera"
import { activitiesService } from "../../data/services/activitiesService"
import { messengerService } from "../../data/services/messengerService"
import { hasRole } from "../../data/utility/ability"
import { findItemInListWithId } from "../../data/utility/dataUtils"
import { AudioRecordingContainer } from "../../student/activity/execute/AudioRecordingContainer"
import { DoneChip } from "../../student/activity/read/DoneChip"
import TodoModal from "../../student/activity/todo/TodoModal"
import { DialogM } from "../components/alert/dialog/Dialog"
import PdfViewerModal from "../components/pdf/PdfViewerModal"
import { isPdfFile } from "../components/pdf/pdfHelpers"
import { useCurrentActivity } from "../hooks/useCurrentActivity"
import useLiveChatUserId from "../hooks/useLiveChatUserId"
import { fetchResourceFromURI, fileFromURI } from "../hooks/useRequestsBatch"
import AudioRecordingModal from "./AudioRecordingModal"

export const clearNotifications = (path) => {
    Notifications.getPresentedNotificationsAsync().then((notifications) => {
        notifications.forEach((notification) => {
            if (path === notification.request.content.data.path) {
                Notifications.dismissNotificationAsync(
                    notification.request.identifier
                ).then()
            }
        })
    })
}

export const countNotifications = async (path) => {
    const notifications = await Notifications.getPresentedNotificationsAsync()

    let i = 0
    notifications.forEach((notification) => {
        if (path === notification.request.content.data.path) {
            i++
        }
    })

    return i
}

const cleanURLsInBody = (body) => {
    // Extract URLs from body
    const urls = body.match(/(https?:\/\/[^\s]+)/g) || []

    // Url encode each url
    const encodedURLs = urls.map((url) => encodeURI(url).replace(/%25/g, "%"))

    // Replace each url in body with encoded url
    let newBody = body
    urls.forEach((url, i) => {
        newBody = newBody.replace(url, encodedURLs[i])
    })

    return newBody
}

export const transformMessage = (x) => {
    return {
        _id: x?.id,
        text:
            x?.image || x?.audio || x?.document
                ? ""
                : // Message bodies are stored as native unicode (device
                  // keyboards emit unicode emoji directly, nothing encodes them
                  // to :shortcodes: on send), so no shortname conversion is
                  // needed here — decoding + URL cleanup is enough.
                  cleanURLsInBody(decode(x?.body)),
        createdAt: x?.created_at,
        user: {
            _id: x?.owner_id,
            name: x?.owner?.name ?? x?.activitySetter?.name,
        },
        image: x?.image ? API_URL + x?.image?.lg : "",
        audio: x?.audio ? API_URL + x?.audio : "",
        document: x?.document ? API_URL + x?.document : "",
        name: x?.name,
        threadId: x?.thread_id,
    }
}

const CommonChat = (props) => {
    const {
        threadId,
        messages,
        setMessages,
        triggerTyping = () => {},
        triggerSendMessage = () => {},
        groupChat = false,
        participants = [],
        liveChat = false,
        unreadMessagesCount,
        tutorId,
        currentUser = null,
        goToMyTutor = () => {},
        nav = null,
        route = null,
        onExit = () => {},
        noBottomInset = false,
    } = props

    const updateRequest = props.postMessagesRequest
    const getMessageRequest = props.getMessagesRequest
    const appState = useRef(AppState.currentState)
    const [currentMsgId, setCurrentMsgId] = useState(null)
    const { setCurrentActivity: setCurrentActivityFromHook } =
        useCurrentActivity()
    const [currentActivity, setCurrentActivity] = useState(null)
    const [openTodoModal, setOpenTodoModal] = useState(false)
    const [pdfFile, setPdfFile] = useState(null)
    const [isSendingPdf, setIsSendingPdf] = useState(false)
    const [fileViewerVisible, setFileViewerVisible] = useState(false)
    const [activityFile, setActivityFile] = useState(null)
    const navigation = nav ? nav : useNavigation()

    const handleShowTodoModal = () => {
        setOpenTodoModal(!openTodoModal)
        setCurrentMsgId(null)
    }

    const handleAppStateChange = async (nextAppState) => {
        if (
            appState.current === "active" &&
            nextAppState.match(/inactive|background/)
        ) {
            // App is going to background
        } else if (
            appState.current.match(/inactive|background/) &&
            nextAppState === "active"
        ) {
            if (Platform.OS !== "web") clearNotifications("messages")
            props.apiRequest(messengerService.getMessages, {
                threadId: threadId,
            })
        }
        appState.current = nextAppState
    }

    const loadEarlier = () => {
        if (props.getPageMessagesRequest || props.getMessagesRequest) return

        const next_page = props.user?.messageMeta?.next_page_id
        props.apiRequest(messengerService.getPageMessages, {
            threadId: threadId,
            pageId: next_page,
        })
    }

    const onSend = (msg = []) => {
        setCurrentMsgId(msg[0]?._id)
        setMessages((old) => GiftedChat.append(old, [msg[0]]))
        props.apiRequest(
            messengerService.postMessages,
            { threadId: threadId },
            { message: msg[0].text, temporary_id: "message" }
        )
        triggerSendMessage(
            "newMessage",
            {
                _id: msg[0]?._id,
                text: msg[0].text,
                createdAt: new moment(),
                user: {
                    _id: props.user?.id,
                    name: props.user?.display_name,
                },
                threadId: threadId,
            },
            currentUser?.id === 0 ? null : [currentUser?.id]
        )
    }

    useEffect(() => {
        if (Platform.OS !== "web") clearNotifications("messages")
        props.apiRequest(messengerService.getMessages, {
            threadId: threadId,
        })

        if (
            currentUser?.id !== 0 &&
            hasRole(props.user, "tutor") &&
            !props.isLiveModeEnabled
        ) {
            const getUserService = studentsService.getStudent
            const getUserParams = { id: currentUser?.id }
            props.apiRequest(getUserService, getUserParams)
        }

        const subscription = Notifications.addNotificationReceivedListener(
            (notification) => {
                if (
                    notification.request.content.data.path === "messages" &&
                    notification.request.content.data.data?.thread_id ===
                        threadId
                ) {
                    setTimeout(() => {
                        Notifications.dismissNotificationAsync(
                            notification.request.identifier
                        ).then()
                    }, 1000)
                }
            }
        )

        const sub = AppState.addEventListener("change", handleAppStateChange)

        return () => {
            if (Platform.OS !== "web") subscription.remove()
            if (!liveChat)
                props.apiRequest(messengerService.getMarkRead, {
                    threadId: threadId,
                })

            sub.remove()
        }

        // Notifications.dismissNotificationAsync("").then(() => {
        // })
    }, [threadId])

    useApiStatus(messengerService.getPageMessages, null, true, () => {
        const messageEarlier = props.user?.messages[threadId]
        setMessages(messageEarlier.map(transformMessage))
    })

    useApiStatus(
        messengerService.getMessages, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            const messageServeur = props.user?.messages[threadId]

            setMessages(messageServeur?.map(transformMessage))

            props.apiRequest(messengerService.getMarkRead, {
                threadId: threadId,
            })
        }
    )
    useApiStatus(
        messengerService.getMarkRead, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {},
        () => {}
    )
    useApiStatus(
        messengerService.postMessages, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            setCurrentMsgId(null)
        }
    )

    const [hasInputText, setHasInputText] = useState(false)

    const [launchCamera] = useCamera("chat", false, false)
    const composerRef = useRef()

    function renderComposer(options) {
        const isTutor = hasRole(props.user, "tutor")
        const title = isTutor
            ? "Crée une activité"
            : "Tu n'es pas autorisé à envoyer une photo dans le groupe. Souhaites tu envoyer une photo à ton tuteur ?"
        const subTitle = isTutor
            ? "Si c'est un travail à faire, crée plutôt une activité pour faciliter le suivi"
            : ""
        const btnText1 = isTutor
            ? "Créer une activité"
            : "envoyer une photo uniquement à mon tuteur"

        if (!isTutor && currentUser?.id === 0)
            return (
                <TextM
                    wrap
                    fontSize={11}
                    fontWeight={"Medium"}
                    style={{
                        alignSelf: "center",
                        marginHorizontal: 10,
                    }}
                >
                    Pour envoyer un message à ton tuteur, clique sur son avatar
                    en haut
                </TextM>
            )

        return (
            <KeyboardAvoidingView
                // Android: SystemBarsFrame already ends the app at the keyboard.
                behavior={Platform.OS === "ios" ? "padding" : undefined}
                style={{ flex: 1 }}
            >
                {!getMessageRequest && (
                    <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            width: "92%",
                            alignItems: "center",
                        }}
                    >
                        <Composer
                            {...options}
                            textInputStyle={{
                                ...options.textInputStyle,
                            }}
                            textInputProps={{
                                ...props.textInputProps,
                                onContentSizeChange: (event) => {
                                    if (!IS_WEB)
                                        setInputHeight(
                                            event?.nativeEvent?.contentSize
                                                ?.height
                                        )
                                },
                                ref: composerRef,
                                blurOnSubmit: IS_WEB,
                                onSubmitEditing: IS_WEB
                                    ? () => {
                                          if (options.text && options.onSend) {
                                              options.onSend(
                                                  { text: options.text.trim() },
                                                  true
                                              )
                                              setTimeout(() => {
                                                  composerRef.current?.focus()
                                              }, 300)
                                          }
                                      }
                                    : undefined,
                            }}
                            textInputAutoFocus={IS_WEB}
                            composerHeight={Math.max(35, inputHeight) + 16}
                        />
                        {!hasInputText &&
                            !updateRequest &&
                            !props.postImagesRequest &&
                            !props.postDocumentsRequest &&
                            !props.postAudioRequest && (
                                <View
                                    style={{
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        marginRight: -30,
                                        alignItems: "center",
                                    }}
                                >
                                    <Pressable
                                        onPress={() => {
                                            if (currentUser?.id === 0) {
                                                showGroupChatConfirm('camera')
                                            } else launchCamera()
                                        }}
                                    >
                                        <FontAwesome5
                                            color={theme.colors.primary}
                                            size={30}
                                            name="camera"
                                            style={{
                                                marginHorizontal: 8,
                                                paddingBottom: 3,
                                            }}
                                        />
                                    </Pressable>
                                    {!IS_WEB && (
                                        <Pressable
                                            onPress={() => {
                                                if (currentUser?.id === 0) {
                                                    showGroupChatConfirm('image')
                                                } else pickImage()
                                            }}
                                        >
                                            <FontAwesome5
                                                color={theme.colors.primary}
                                                size={30}
                                                name="image"
                                                style={{
                                                    marginHorizontal: 8,
                                                    paddingBottom: 3,
                                                }}
                                            />
                                        </Pressable>
                                    )}
                                    <Pressable
                                        onPress={() => {
                                            if (currentUser?.id === 0) {
                                                showGroupChatConfirm('file')
                                            } else pickFile()
                                        }}
                                    >
                                        <FontAwesome5
                                            color={theme.colors.primary}
                                            size={30}
                                            name="file-image"
                                            style={{
                                                marginHorizontal: 8,
                                                paddingBottom: 3,
                                            }}
                                        />
                                    </Pressable>
                                    <Pressable
                                        onPress={() => {
                                            setVisible(true)
                                        }}
                                    >
                                        <FontAwesome5
                                            color={theme.colors.primary}
                                            size={30}
                                            name="microphone"
                                            style={{
                                                marginHorizontal: 8,
                                                paddingBottom: 3,
                                            }}
                                        />
                                    </Pressable>
                                </View>
                            )}
                    </View>
                )}
            </KeyboardAvoidingView>
        )
    }

    const [inputHeight, setInputHeight] = useState(0)
    const dimensions = useContext(DimensionsContext)

    const pickFile = async () => {
        const result = await DocumentPicker.getDocumentAsync({
            type: ["application/pdf", "image/*"],
        })

        if (result.canceled) {
            return
        }

        const asset = result.assets[0]
        const fileName = asset.name.split(".")[0].replace(/[\s.]+/g, "_")

        const isPdf = isPdfFile(asset)

        const file = {
            uri: asset.uri,
            name: `${fileName}_${moment().format("YYYY-MM-DD")}.${
                isPdf ? "pdf" : "png"
            }`,
            size: asset.size,
            mimeType: asset.mimeType,
        }

        if (isPdf) {
            setPdfFile(file)
            setIsSendingPdf(true)
        } else {
            props.setNewPhoto("chat", file)
        }
    }

    // Said in the chat itself: in a live, a dialog, a toast or a snackbar
    // opens under the chat window.
    const [unsentNotice, setUnsentNotice] = useState(false)
    const showUnsentNotice = () => {
        setUnsentNotice(true)
        setTimeout(() => setUnsentNotice(false), 6000)
    }

    // The web uploads the File behind the address; native lets FormData read
    // the uri itself. Null when the file can no longer be read (a `blob:`
    // address dies with a reload, and the pending photo is persisted): it is
    // dropped, or the chat would retry it at every opening.
    const uploadPart = async (file) => {
        if (!IS_WEB) return file
        try {
            return await fileFromURI(file.uri, file.name, file.type)
        } catch (error) {
            // Caught, so reported by hand: a dead `blob:` address is expected
            // here, any other scheme means the web can no longer read a file.
            notifyBugsnag(error, {
                step: "chat upload: file unreadable",
                uriScheme: file.uri?.split(":")[0],
                formId: props.lastPhotoFormId,
            })
            props.clearLastPhoto()
            setPdfFile(null)
            setIsSendingPdf(false)
            setSendingMediaToChat(false)
            showUnsentNotice()
            return null
        }
    }

    const onSendPdf = async () => {
        if (!pdfFile) return

        const pdfFileObj = {
            uri: pdfFile.uri,
            name: pdfFile.name,
            type: "application/pdf",
        }

        const documentPart = await uploadPart(pdfFileObj)
        if (!documentPart) return

        const cleanFormData = new FormData()

        cleanFormData.append("temporary_id", "test")
        cleanFormData.append("document", documentPart)

        const temporaryId = `temporaryMsg_${Date.now()}_${Math.random()
            .toString(36)
            .substring(2, 9)}`
        const temporaryMsg = {
            _id: temporaryId,
            text: "",
            createdAt: moment.now(),
            user: {
                _id: props.user?.id,
                name: props.user?.display_name,
            },
            document: pdfFile.uri,
            name: pdfFileObj.name.replace(/[\s.]+/g, "_"),
            threadId: threadId,
        }

        setCurrentMsgId(temporaryMsg?._id)
        setMessages((old) => GiftedChat.append(old, [temporaryMsg]))

        await props.apiRequest(
            messengerService.postDocument,
            { threadId: threadId },
            cleanFormData
        )

        setFileViewerVisible(false)
        setPdfFile(null)
        setIsSendingPdf(false)
    }

    const renderMessagePdf = (data) => {
        const userId = data?.currentMessage?.user?._id
        const pdfUri = cleanMediaUrl(data?.currentMessage?.document)
        const pdfName = data?.currentMessage?.name

        const student = hasRole(props.user, "student")
            ? props.user
            : currentUser
        const activity = student?.todo_activities
            ?.concat(student?.activities)
            ?.find((x) => x?.message_id === data?.currentMessage?._id)

        return (
            <TouchableRippleM
                onPress={() => {
                    // For tutors with a specific student
                    if (hasRole(props.user, "tutor") && currentUser?.id !== 0) {
                        // Check if activity already exists for this message
                        if (activity) {
                            // Open TodoModal with existing activity
                            setCurrentActivity(activity)
                            handleShowTodoModal()
                        } else {
                            // No activity: open MediaPreviewModal to create one
                            setMediaPreviewFile({
                                uri: pdfUri,
                                name: pdfName || `document_${data?.currentMessage?._id}.pdf`,
                                messageId: data?.currentMessage?._id, // Pass message ID for backend
                            })
                            setIsMediaFromExistingMessage(true)
                            setShowMediaPreview(true)
                        }
                        return
                    }

                    // For students or group chat: use existing flow
                    props.apiRequest(messengerService.getActivityFromChat, {
                        id: data?.currentMessage?._id,
                    })
                    const file = { uri: pdfUri }
                    setPdfFile(file)
                    setActivityFile(file)
                    setCurrentMsgId(data?.currentMessage?._id)
                }}
                style={{
                    padding: 10,
                }}
            >
                <>
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor:
                                userId === props.user?.id
                                    ? theme.colors.primary
                                    : theme.colors.white,
                            borderRadius: 8,
                            padding: 10,
                            width: 250,
                        }}
                    >
                        <FontAwesome5
                            name="file-pdf"
                            size={24}
                            color={
                                userId === props.user?.id
                                    ? theme.colors.white
                                    : theme.colors.primary
                            }
                            style={{ marginRight: 10 }}
                        />

                        {props.getActivityFromChatRequest &&
                        props.getActivityFromChatId ===
                            data?.currentMessage?._id ? (
                            <ActivityIndicator
                                color={
                                    userId === props.user?.id
                                        ? theme.colors.white
                                        : theme.colors.primary
                                }
                                style={{
                                    marginLeft: 10,
                                }}
                            />
                        ) : (
                            <TextM
                                color={
                                    userId === props.user?.id
                                        ? theme.colors.white
                                        : theme.colors.primary
                                }
                                style={{ padding: 10, margin: 4 }}
                            >
                                {pdfName ||
                                    pdfUri.split("/").pop() ||
                                    "Document PDF"}
                            </TextM>
                        )}
                    </View>
                    {activity && (
                        <View
                            style={{
                                position: "absolute",
                                bottom: 10,
                                right: 10,
                            }}
                        >
                            <DoneChip count={0} status={activity?.status} />
                        </View>
                    )}
                </>
            </TouchableRippleM>
        )
    }

    useEffect(() => {
        if (isSendingPdf) {
            if (hasRole(props.user, "tutor") && currentUser?.id !== 0) {
                // New simplified flow: open MediaPreviewModal
                setMediaPreviewFile(pdfFile)
                setIsMediaFromExistingMessage(false)
                setShowMediaPreview(true)
                setIsSendingPdf(false)
            } else {
                onSendPdf()
            }
        }
    }, [pdfFile, isSendingPdf])

    const pickImage = async () => {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ["images"],
            quality: 1,
        })

        if (!result.canceled) {
            props.setNewPhoto("chat", result.assets[0])
        }
    }

    const onSendImage = async () => {
        const image = await uploadPart({
            uri: props.lastPhoto?.uri,
            name: `Masteur_Image_${props.user?.display_name}_${moment().format(
                "YYYY-MM-DD"
            )}.png`,
            type: "image/png",
        })
        if (!image) return

        const cleanFormData = new FormData()
        cleanFormData.append("temporary_id", "test")
        cleanFormData.append("image", image)

        const temporaryId = `temporaryMsg_${Date.now()}_${Math.random()
            .toString(36)
            .substring(2, 9)}`
        const temporaryMsg = {
            _id: temporaryId,
            text: "",
            createdAt: moment.now(),
            user: {
                _id: props.user?.id,
                name: props.user?.display_name,
            },
            image: props.lastPhoto?.uri,
            threadId: threadId,
        }
        setCurrentMsgId(temporaryMsg?._id)
        setMessages((old) => GiftedChat.append(old, [temporaryMsg]))
        await props.apiRequest(
            messengerService.postImage,
            { threadId: threadId },
            cleanFormData
        )
        props.clearLastPhoto()
    }

    useEffect(() => {
        if (props.lastPhotoFormId === "chat" && !!props.lastPhoto) {
            if (hasRole(props.user, "tutor") && currentUser?.id !== 0) {
                // New simplified flow: open MediaPreviewModal
                setMediaPreviewFile(props.lastPhoto)
                setIsMediaFromExistingMessage(false)
                setShowMediaPreview(true)
            } else {
                onSendImage()
            }
        }
    }, [props.lastPhoto])

    const updateMessagesAfterUpload = (newMessage) => {
        const updatedMessages = [...messages]

        if (updatedMessages.length > 0 && currentMsgId) {
            const tempMsgIndex = updatedMessages.findIndex(
                (msg) => msg._id === currentMsgId
            )

            if (tempMsgIndex !== -1) {
                updatedMessages[tempMsgIndex] = transformMessage(newMessage)
                setMessages(updatedMessages)
            } else {
                const transformedMessage = transformMessage(newMessage)
                setMessages((prevMessages) =>
                    GiftedChat.append(prevMessages, [transformedMessage])
                )
            }
        } else {
            const transformedMessage = transformMessage(newMessage)
            setMessages((prevMessages) =>
                GiftedChat.append(prevMessages, [transformedMessage])
            )
        }
    }

    // A file the server refuses (too heavy, a format it does not take) must
    // not leave a bubble that looks sent.
    const onUploadRefused = () => {
        setMessages((old) => old.filter((message) => message._id !== currentMsgId))
        setCurrentMsgId(null)
        showUnsentNotice()
    }

    useApiStatus(
        messengerService.postDocument, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData, successAlldata) => {
            triggerSendMessage(
                "newMessage",
                successAlldata,
                currentUser?.id === 0 ? null : [currentUser?.id]
            )
            updateMessagesAfterUpload(successAlldata)
            setCurrentMsgId(null)
        },
        onUploadRefused
    )

    useApiStatus(
        messengerService.postImage, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData, successAlldata) => {
            triggerSendMessage(
                "newMessage",
                successAlldata,
                currentUser?.id === 0 ? null : [currentUser?.id]
            )
            updateMessagesAfterUpload(successAlldata)
            setCurrentMsgId(null)
        },
        onUploadRefused
    )
    useApiStatus(
        messengerService.postAudio, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData, successAlldata) => {
            triggerSendMessage(
                "newMessage",
                successAlldata,
                currentUser?.id === 0 ? null : [currentUser?.id]
            )
            updateMessagesAfterUpload(successAlldata)
            setCurrentMsgId(null)
        }
    )
    const customMessage = (props) => {
        return (
            <Message
                {...props}
                containerStyle={{
                    left: {
                        alignItems: "flex-start",
                    },
                    right: {
                        alignItems: "flex-start",
                    },
                }}
            />
        )
    }

    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleShowFileModal = (onClose = true) => {
        const newModalOpenState = !isModalOpen
        setIsModalOpen(newModalOpenState)

        if (!newModalOpenState && onClose) {
            if (props.lastPhoto && hasRole(props.user, "tutor")) {
                onSendImage()
            }

            if (isSendingPdf && hasRole(props.user, "tutor")) {
                onSendPdf()
            }
        }
    }

    const [recordingURI, setRecordingURI] = useState(null)
    const [time, setTime] = useState(0)
    const [visible, setVisible] = useState(false)
    const handleShowModal = () => {
        setVisible(!visible)
        // setActivityFile(null)
        // props.clearLastPhoto()
    }

    const onAudioSend = async () => {
        const cleanFormData = new FormData()
        const audio = IS_WEB
            ? await fetchResourceFromURI(recordingURI)
            : {
                  uri: recordingURI,
                  name: `Masteur_audio${
                      props.user?.display_name
                  }_${moment().format("YYYY-MM-DD")}.m4a`,
                  type: "audio/m4a",
              }
        cleanFormData.append("audio", audio)
        cleanFormData.append("temporary_id", "test")
        const temporaryMsg = {
            _id: "temporaryMsg",
            text: "",
            createdAt: moment.now(),
            user: {
                _id: props.user?.id,
                name: props.user?.display_name,
            },
            audio: recordingURI,
        }
        setCurrentMsgId(temporaryMsg?._id)
        setMessages((old) => GiftedChat.append(old, [temporaryMsg]))
        props.apiRequest(
            messengerService.postAudio,
            { threadId: threadId },
            cleanFormData
        )
        setRecordingURI(null)
        handleShowModal()
    }

    const renderMessageAudio = (data) => {
        const userId = data?.currentMessage?.user?._id
        return (
            <View
                style={{
                    padding: 10,
                    width: 260,
                }}
            >
                <AudioRecordingContainer
                    recordingURI={cleanMediaUrl(data?.currentMessage?.audio)}
                    readOnly
                    chatMode
                    color={
                        userId === props.user?.id
                            ? theme.colors.white
                            : theme.colors.primary
                    }
                />
            </View>
        )
    }
    const renderTicks = (data) => {
        const userId = data?.currentMessage?.user?._id
        const messageId = data?.currentMessage?._id
        return (
            userId === props.user?.id &&
            messageId === currentMsgId &&
            updateRequest && (
                <ActivityIndicator
                    animating={true}
                    color={theme.colors.white}
                    style={{ marginHorizontal: 4 }}
                    size={12}
                />
            )
        )
    }
    const renderCustomView = (data) => {
        const userId = data?.currentMessage?.user?._id
        const messageId = data?.currentMessage?._id
        return (
            userId === props.user?.id &&
            messageId === currentMsgId &&
            (props.postImagesRequest || props.postDocumentsRequest) && (
                <ActivityIndicator
                    animating={true}
                    color={theme.colors.white}
                    style={{ marginHorizontal: 4 }}
                    size={22}
                />
            )
        )
    }

    const insets = useSafeAreaInsets()

    const [scrolling, setScrolling] = useState(false)
    useEffect(() => {
        if (unreadMessagesCount > 0) {
            setTimeout(() => {
                props.changeCount(
                    tutorId
                        ? {
                              tutorId: tutorId,
                              value: 0,
                          }
                        : 0
                )
                if (threadId)
                    props.changeUnreadMessageInLiveCount(threadId, null, 0)
            }, 3000)
        }
    }, [unreadMessagesCount])

    const { liveChatUserId } = useLiveChatUserId(navigation, route)

    const [images, setImages] = useState([])
    // Index of the image first shown when opening either viewer, so the arrows
    // start on the image the user actually tapped
    const [currentImageIndex, setCurrentImageIndex] = useState(0)

    // All image messages of the conversation, oldest → newest (GiftedChat keeps
    // messages newest-first), so both viewers can navigate between them with arrows
    const chatImageFiles = useMemo(
        () =>
            [...(messages ?? [])]
                .reverse()
                .filter((message) => message?.image)
                .map((message) => ({
                    uri: cleanMediaUrl(message.image),
                    name: `image_${message._id}`,
                    messageId: message._id,
                })),
        [messages]
    )

    // Handler: navigate between chat images inside MediaPreviewModal
    const handleNavigateMediaPreview = (newIndex) => {
        if (newIndex < 0 || newIndex >= chatImageFiles.length) return
        setCurrentImageIndex(newIndex)
        setMediaPreviewFile(chatImageFiles[newIndex])
    }

    // New simplified flow state
    const [showMediaPreview, setShowMediaPreview] = useState(false)
    const [mediaPreviewFile, setMediaPreviewFile] = useState(null)
    const [isMediaFromExistingMessage, setIsMediaFromExistingMessage] = useState(false)
    const [showGenerateActivityModal, setShowGenerateActivityModal] = useState(false)
    const [sendingMediaToChat, setSendingMediaToChat] = useState(false)
    const [initialImageForModal, setInitialImageForModal] = useState(null)

    // Confirmation modal state (replaces DialogM for group chat to fix z-index issues)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [confirmModalAction, setConfirmModalAction] = useState(null) // 'camera' | 'image' | 'file'

    // Handler: Show confirmation modal for group chat actions
    const showGroupChatConfirm = (action) => {
        setConfirmModalAction(action)
        setShowConfirmModal(true)
    }

    // Handler: Execute confirmed action
    const handleConfirmAction = () => {
        const isTutor = hasRole(props.user, "tutor")

        if (confirmModalAction === 'camera') {
            if (isTutor) {
                navigation.push("new-todo", { forStudents: true })
            } else {
                goToMyTutor()
                launchCamera()
            }
        } else if (confirmModalAction === 'image') {
            if (isTutor) {
                navigation.push("new-todo", { forStudents: true })
            } else {
                goToMyTutor()
                pickImage()
            }
        } else if (confirmModalAction === 'file') {
            if (isTutor) {
                navigation.push("new-todo", { forStudents: true })
            } else {
                goToMyTutor()
                pickFile()
            }
        }

        setShowConfirmModal(false)
        setConfirmModalAction(null)
    }

    // Handler: Send anyway (alternative action)
    const handleSendAnyway = () => {
        if (confirmModalAction === 'camera') {
            launchCamera()
        } else if (confirmModalAction === 'image') {
            pickImage()
        } else if (confirmModalAction === 'file') {
            pickFile()
        }

        setShowConfirmModal(false)
        setConfirmModalAction(null)
    }

    // Handler: Create activity from MediaPreviewModal
    const handleCreateActivityFromPreview = () => {
        setShowMediaPreview(false)
        // Prepare the image for GenerateActivityModal
        const imageFile = {
            uri: mediaPreviewFile?.uri,
            name: mediaPreviewFile?.name || `file_${Date.now()}`,
            mimeType: isPdfFile(mediaPreviewFile) ? "application/pdf" : "image/png",
            messageId: mediaPreviewFile?.messageId, // Pass message ID for existing messages
        }
        setInitialImageForModal(imageFile)
        setShowGenerateActivityModal(true)
        // Clear lastPhoto if it was a new file
        if (!isMediaFromExistingMessage && props.lastPhoto) {
            props.clearLastPhoto()
        }
    }

    // Handler: Send media to chat from MediaPreviewModal
    const handleSendMediaToChat = async () => {
        setSendingMediaToChat(true)
        const isPdf = isPdfFile(mediaPreviewFile)

        const part = await uploadPart(
            isPdf
                ? {
                      uri: mediaPreviewFile.uri,
                      name: mediaPreviewFile.name || `document_${Date.now()}.pdf`,
                      type: "application/pdf",
                  }
                : {
                      uri: mediaPreviewFile?.uri,
                      name: `Masteur_Image_${props.user?.display_name}_${moment().format("YYYY-MM-DD")}.png`,
                      type: "image/png",
                  }
        )
        if (!part) {
            setShowMediaPreview(false)
            setMediaPreviewFile(null)
            return
        }

        if (isPdf) {
            // Send PDF
            const cleanFormData = new FormData()
            cleanFormData.append("temporary_id", "test")
            cleanFormData.append("document", part)

            const temporaryId = `temporaryMsg_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
            const temporaryMsg = {
                _id: temporaryId,
                text: "",
                createdAt: moment.now(),
                user: { _id: props.user?.id, name: props.user?.display_name },
                document: mediaPreviewFile.uri,
                name: part.name,
                threadId: threadId,
            }
            setCurrentMsgId(temporaryMsg?._id)
            setMessages((old) => GiftedChat.append(old, [temporaryMsg]))

            await props.apiRequest(messengerService.postDocument, { threadId }, cleanFormData)
        } else {
            // Send Image
            const cleanFormData = new FormData()
            cleanFormData.append("temporary_id", "test")
            cleanFormData.append("image", part)

            const temporaryId = `temporaryMsg_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
            const temporaryMsg = {
                _id: temporaryId,
                text: "",
                createdAt: moment.now(),
                user: { _id: props.user?.id, name: props.user?.display_name },
                image: mediaPreviewFile?.uri,
                threadId: threadId,
            }
            setCurrentMsgId(temporaryMsg?._id)
            setMessages((old) => GiftedChat.append(old, [temporaryMsg]))

            await props.apiRequest(messengerService.postImage, { threadId }, cleanFormData)
        }

        // Close modal and cleanup
        setSendingMediaToChat(false)
        setShowMediaPreview(false)
        setMediaPreviewFile(null)
        if (props.lastPhoto) {
            props.clearLastPhoto()
        }
    }

    // Handler: Close GenerateActivityModal
    const handleCloseGenerateActivityModal = () => {
        setShowGenerateActivityModal(false)
        setInitialImageForModal(null)
        setMediaPreviewFile(null)
    }

    const renderMessageImage = (data) => {
        const userId = data?.currentMessage?.user?._id
        const uri = cleanMediaUrl(data?.currentMessage?.image)

        const student = hasRole(props.user, "student")
            ? props.user
            : currentUser
        const activity = student?.todo_activities
            ?.concat(student?.activities)
            ?.find((x) => x?.message_id === data?.currentMessage?._id)

        return (
            <TouchableRippleM
                onPress={() => {
                    // Position of the tapped image within the conversation, so
                    // whichever viewer opens starts on it (-1 → fall back to 0)
                    const tappedIndex = chatImageFiles.findIndex(
                        (image) =>
                            image.messageId === data?.currentMessage?._id
                    )
                    setCurrentImageIndex(tappedIndex >= 0 ? tappedIndex : 0)

                    // For tutors with a specific student
                    if (hasRole(props.user, "tutor") && currentUser?.id !== 0) {
                        // Check if activity already exists for this message
                        if (activity) {
                            // Open TodoModal with existing activity
                            setCurrentActivity(activity)
                            handleShowTodoModal()
                        } else {
                            // No activity: open MediaPreviewModal to create one,
                            // seeded with every chat image so the tutor can flip
                            // between them with the navigation arrows
                            setMediaPreviewFile(
                                chatImageFiles[tappedIndex] ?? {
                                    uri,
                                    name: `image_${data?.currentMessage?._id}`,
                                    messageId: data?.currentMessage?._id, // Pass message ID for backend
                                }
                            )
                            setIsMediaFromExistingMessage(true)
                            setShowMediaPreview(true)
                        }
                        return
                    }

                    // For students or group chat: use existing flow.
                    // Load every chat image so the viewer arrows can navigate
                    // between them, starting on the tapped one.
                    props.apiRequest(messengerService.getActivityFromChat, {
                        id: data?.currentMessage?._id,
                    })
                    setImages(
                        chatImageFiles.length > 0
                            ? chatImageFiles.map((image) => image.uri)
                            : [uri]
                    )
                    setActivityFile({
                        uri,
                    })
                    setCurrentMsgId(data?.currentMessage?._id)
                }}
                style={{
                    padding: 10,
                }}
            >
                <>
                    <IconImageM
                        uri={uri}
                        width={250}
                        height={120}
                        style={{
                            alignSelf: "center",
                            backgroundColor: theme.colors.black,
                            marginTop: 15,
                            opacity:
                                props.getActivityFromChatRequest &&
                                props.getActivityFromChatId ===
                                    data?.currentMessage?._id
                                    ? 0.2
                                    : 1,
                        }}
                    />
                    {props.getActivityFromChatRequest &&
                        props.getActivityFromChatId ===
                            data?.currentMessage?._id && (
                            <ActivityIndicator
                                color={
                                    userId === props.user?.id
                                        ? theme.colors.white
                                        : theme.colors.primary
                                }
                                style={{
                                    position: "absolute",
                                    alignSelf: "center",
                                    top: 55,
                                }}
                            />
                        )}
                    {activity && (
                        <View
                            style={{
                                position: "absolute",
                                bottom: 10,
                                right: 10,
                            }}
                        >
                            <DoneChip count={0} status={activity?.status} />
                        </View>
                    )}
                </>
            </TouchableRippleM>
        )
    }

    useApiStatus(
        activitiesService.getActivities, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (data) => {
            // if we find activity in data (array) with same id as currentActivity, we replace it in currentActivity state
            const foundActivity = data.find(
                (activity) => activity.id === currentActivity?.id
            )
            if (foundActivity) setCurrentActivity(foundActivity)
        } // success callback
    )

    useApiStatus(
        messengerService.getActivityFromChat, // api service
        null, // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        (successData) => {
            setCurrentActivity(successData)
            if (hasRole(props.user, "student")) {
                setCurrentActivityFromHook({
                    activityData: successData,
                    progressStatus: successData?.finished_at
                        ? "finished"
                        : "ongoing",
                })

                if (liveChatUserId) {
                    onExit()
                } else {
                    navigation.replace("activity")
                }
            } else {
                handleShowTodoModal()
            }
            props.apiIdle(messengerService.getActivityFromChat)
        },
        () => {
            setFileViewerVisible(true)
            setCurrentActivity(null)
            if (!hasRole(props.user, "student")) {
                handleShowFileModal()
            }
            props.apiIdle(messengerService.getActivityFromChat)
        }
    )

    const renderFileViewer = () => {
        if (
            (fileViewerVisible && hasRole(props.user, "student")) ||
            currentUser?.id === 0
        ) {
            if (pdfFile) {
                return (
                    <PdfViewerModal
                        visible={fileViewerVisible}
                        onDismiss={() => {
                            setFileViewerVisible(false)
                            setPdfFile(null)
                        }}
                        pdfFile={pdfFile}
                    />
                )
            }

            if (images.length > 0) {
                return (
                    <ImageViewerModal
                        visible={fileViewerVisible}
                        onDismiss={() => {
                            setFileViewerVisible(false)
                        }}
                        imageIndex={currentImageIndex}
                        images={images}
                    />
                )
            }
        }

        return null
    }

    const { sendLiveKitData: sendNewTodo } = useLiveKitEventSender()

    useApiStatus(
        activitiesService.deleteActivitiesTodo, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (data) => {
            sendNewTodo(
                "deleteTodo",
                {
                    id: currentUser?.id,
                    activity_ids: data?.deleted_activity_ids || [],
                },
                [currentUser?.id]
            )
        } // success callback
    )

    const onDeleteTodo = () => {
        onExit()
        DialogM.show({
            text1: "Veux-tu archiver cette activité ?",
            text2: "Tu pourras la restaurer depuis les activités archivées.",
            buttonText1: "Archiver",
            buttonColor1: theme.colors.primary,
            onPress: () => {
                props.apiRequest(
                    activitiesService.deleteActivitiesTodo,
                    { student: currentUser?.id },
                    {
                        activity_ids: [currentActivity?.id],
                    }
                )
            },
            buttonText2: "Annuler",
        })
    }

    useEffect(() => {
        if (!props.lastPhoto && !props.lastPhotoFormId) {
            setIsModalOpen(false)
        }
    }, [])

    return (
        <>
            <View
                style={{
                    flex: 1,
                    paddingBottom: noBottomInset ? 0 : insets.bottom,
                }}
            >
                <GiftedChat
                    // Android: SystemBarsFrame already ends the app at the keyboard.
                    isKeyboardInternallyHandled={Platform.OS !== "android"}
                    messagesContainerStyle={{
                        width: dimensions?.width,
                        paddingBottom: Math.max(20, inputHeight - 24),
                    }}
                    wrapInSafeArea={false}
                    messages={messages}
                    listViewProps={{
                        onEndReached:
                            !props.user?.messageMeta?.final_page && IS_WEB
                                ? loadEarlier
                                : () => {},
                        onEndReachedThreshold: 0.3,
                        onScroll: ({ nativeEvent }) => {
                            if (!scrolling && nativeEvent.contentOffset.y !== 0)
                                setScrolling(true)
                            else setScrolling(false)
                        },
                    }}
                    renderCustomView={(props) => {
                        if (props.currentMessage.document) {
                            return (
                                <>
                                    {renderMessagePdf(props)}
                                    {renderCustomView(props)}
                                </>
                            )
                        } else {
                            return renderCustomView(props)
                        }
                    }}
                    isCustomViewBottom
                    renderMessage={(props) => customMessage(props)}
                    locale={fr}
                    timeFormat={"HH:mm"}
                    dateFormat={"ddd DD MMM"}
                    dateFormatCalendar={{ sameDay: "[Aujourd'hui]" }}
                    infiniteScroll
                    isAnimated
                    onSend={(messages) => onSend(messages)}
                    onLongPress={(context, currentMessage) => {
                        const options = ["Copier", "Annuler"]
                        const cancelButtonIndex = options.length - 1
                        context.actionSheet().showActionSheetWithOptions(
                            {
                                options,
                                cancelButtonIndex,
                            },
                            (buttonIndex) => {
                                switch (buttonIndex) {
                                    case 0:
                                        Clipboard.setStringAsync(
                                            currentMessage.text
                                        ).then()
                                        break
                                }
                            }
                        )
                    }}
                    user={{
                        _id: props.user?.id,
                        avatar: groupChat ? props.user?.avatar : null,
                        name: props.user?.display_name,
                    }}
                    renderComposer={renderComposer}
                    renderMessageAudio={renderMessageAudio}
                    renderMessageImage={renderMessageImage}
                    renderFooter={() => {
                        return (
                            groupChat && (
                                <View
                                    style={{
                                        flexDirection: "row",
                                    }}
                                >
                                    {props.isTyping && (
                                        <AvatarM
                                            user={props.currentLiveSession?.users?.find(
                                                (x) =>
                                                    x?.id === props.typingUser
                                            )}
                                            style={{
                                                marginHorizontal: 10,
                                            }}
                                        />
                                    )}

                                    <TypingIndicator
                                        isTyping={props.isTyping}
                                    />
                                </View>
                            )
                        )
                    }}
                    renderUsernameOnMessage={groupChat}
                    shouldUpdateMessage={() => {
                        return true
                    }}
                    onLoadEarlier={loadEarlier}
                    renderLoadEarlier={() => {
                        return (
                            <LoadEarlier
                                isLoadingEarlier={props.getPageMessagesRequest}
                                label=""
                                wrapperStyle={{
                                    backgroundColor: theme.colors.transparent,
                                }}
                                activityIndicatorColor={theme.colors.primary}
                            />
                        )
                    }}
                    loadEarlier={!props.user?.messageMeta?.final_page}
                    renderLoading={() => {
                        return (
                            <View
                                style={{
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <ActivityIndicator
                                    animating={true}
                                    color={theme.colors.primary}
                                    size={40}
                                />
                            </View>
                        )
                    }}
                    onInputTextChanged={(text) => {
                        if (text !== "") {
                            triggerTyping(
                                "typing",
                                {},
                                currentUser?.id === 0 ? null : [currentUser?.id]
                            )
                            setHasInputText(true)
                        } else setHasInputText(false)
                    }}
                    renderInputToolbar={(props) => {
                        return (
                            <InputToolbar
                                {...props}
                                placeholder="Écrire un message..."
                                textInputStyle={{
                                    color: theme.colors.black,
                                    fontFamily: "Montserrat-Regular",
                                    paddingTop:
                                        IS_WEB || Platform.OS === "ios"
                                            ? 10
                                            : 0,
                                }}
                                accessoryStyle={{
                                    borderWidth: 0,
                                }}
                                containerStyle={{
                                    height: Math.max(45, inputHeight) + 16,

                                    borderTopLeftRadius: IS_WEB ? 20 : 0,
                                    borderTopRightRadius: IS_WEB ? 20 : 0,
                                }}
                                primaryStyle={{
                                    height: Math.max(45, inputHeight) + 16,
                                }}
                            />
                        )
                    }}
                    renderSend={(props) => {
                        return (
                            <>
                                {getMessageRequest ? (
                                    <ActivityIndicator
                                        animating={true}
                                        color={theme.colors.primary}
                                        size={25}
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: 10,
                                        }}
                                    />
                                ) : updateRequest ? (
                                    <></>
                                ) : (
                                    <Send {...props}>
                                        <FontAwesome5
                                            color={theme.colors.primary}
                                            size={35}
                                            solid
                                            name="arrow-alt-circle-right"
                                            style={{
                                                paddingBottom: 20,
                                                marginLeft: -16,
                                            }}
                                        />
                                    </Send>
                                )}
                            </>
                        )
                    }}
                    showAvatarForEveryMessage={groupChat}
                    renderAvatar={
                        groupChat
                            ? (data) => {
                                  const user = participants?.find(
                                      (u) =>
                                          u.id ===
                                          data.currentMessage?.user?._id
                                  )
                                  return <AvatarM user={user} />
                              }
                            : null
                    }
                    renderBubble={(props) => {
                        return (
                            <Bubble
                                {...props}
                                renderTicks={() => renderTicks(props)}
                                textStyle={{
                                    right: {
                                        color: "white",
                                        fontFamily: "Montserrat-Regular",
                                        maxWidth: dimensions?.width / 1.5,
                                    },
                                    left: {
                                        color: "#24204F",
                                        fontFamily: "Montserrat-Regular",
                                        maxWidth: dimensions?.width / 1.5,
                                    },
                                }}
                                wrapperStyle={{
                                    left: {
                                        backgroundColor: theme.colors.white,
                                    },
                                    right: {
                                        backgroundColor: theme.colors.primary,
                                    },
                                }}
                            />
                        )
                    }}
                    scrollToBottom
                    scrollToBottomComponent={() => {
                        return (
                            <FontAwesome5
                                name="angle-double-down"
                                size={22}
                                color={theme.colors.primary}
                            />
                        )
                    }}
                />
                {unsentNotice && (
                    <View
                        style={{
                            position: "absolute",
                            top: 8,
                            left: 16,
                            right: 16,
                            padding: 10,
                            borderRadius: 8,
                            backgroundColor: theme.colors.error,
                        }}
                    >
                        <TextM color={theme.colors.white} wrap>
                            Ce fichier n'a pas pu être envoyé. Choisis-le à
                            nouveau.
                        </TextM>
                    </View>
                )}
            </View>

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />

            <AudioRecordingModal
                visible={visible}
                onDismiss={handleShowModal}
                setTime={setTime}
                recordingURI={recordingURI}
                setRecordingURI={setRecordingURI}
                onSend={onAudioSend}
            />

            {renderFileViewer()}

            {/* New simplified flow: MediaPreviewModal */}
            <MediaPreviewModal
                visible={showMediaPreview}
                onDismiss={() => {
                    setShowMediaPreview(false)
                    setMediaPreviewFile(null)
                    if (!isMediaFromExistingMessage && props.lastPhoto) {
                        props.clearLastPhoto()
                    }
                }}
                file={mediaPreviewFile}
                isExistingMessage={isMediaFromExistingMessage}
                images={isMediaFromExistingMessage ? chatImageFiles : []}
                currentIndex={currentImageIndex}
                onNavigate={handleNavigateMediaPreview}
                onCreateActivity={handleCreateActivityFromPreview}
                onSendToChat={handleSendMediaToChat}
                sendingToChat={sendingMediaToChat}
                dimensions={dimensions}
            />

            {/* GenerateActivityModal with initial image */}
            {showGenerateActivityModal && (
                <GenerateActivityModal
                    isOpen={showGenerateActivityModal}
                    onClose={handleCloseGenerateActivityModal}
                    student={currentUser}
                    schoolSubjects={props.schoolSubjects}
                    nav={navigation}
                    initialImage={initialImageForModal}
                />
            )}

            {openTodoModal && (
                <TodoModal
                    isOpen={openTodoModal}
                    handleShowModal={handleShowTodoModal}
                    item={currentActivity}
                    onDeleteTodo={onDeleteTodo}
                    studentId={currentActivity?.student_id}
                    schoolSubject={findItemInListWithId(
                        currentActivity?.school_subject_id,
                        props.schoolSubjects
                    )}
                    navigation={navigation}
                    route={route}
                />
            )}

            {/* Group chat confirmation modal - replaces DialogM to fix z-index issues */}
            <ModalM
                visible={showConfirmModal}
                onDismiss={() => {
                    setShowConfirmModal(false)
                    setConfirmModalAction(null)
                }}
                style={{
                    backgroundColor: theme.colors.white,
                    padding: 32,
                    borderRadius: 16,
                    maxWidth: 450,
                    minWidth: 320,
                }}
            >
                <View style={{ gap: 10 }}>
                    {/* Title */}
                    <TextM fontSize={18} fontWeight="Bold" color={theme.colors.primary}>
                        {hasRole(props.user, "tutor")
                            ? "Crée une activité"
                            : "Tu n'es pas autorisé à envoyer une photo dans le groupe"}
                    </TextM>

                    {/* Subtitle */}
                    {hasRole(props.user, "tutor") && (
                        <TextM fontSize={14} color={theme.colors.grey} wrap>
                            Si c'est un travail à faire, crée plutôt une activité pour faciliter le suivi
                        </TextM>
                    )}

                    {/* Buttons */}
                    <View style={{ gap: 4, marginTop: 8 }}>
                        {/* <FilledButtonM
                            label={hasRole(props.user, "tutor")
                                ? "Créer une activité"
                                : "Envoyer une photo uniquement à mon tuteur"}
                            onPress={handleConfirmAction}
                            color={theme.colors.primary}
                        /> */}

                        {hasRole(props.user, "tutor") && (
                            <FilledButtonM
                                label={confirmModalAction === 'camera'
                                    ? "Envoyer quand même une photo"
                                    : confirmModalAction === 'image'
                                    ? "Envoyer quand même une image"
                                    : "Envoyer quand même un fichier"}
                                onPress={handleSendAnyway}
                                mode="outlined"
                                color={theme.colors.primary}
                            />
                        )}

                        <FilledButtonM
                            label="Revenir"
                            onPress={() => {
                                setShowConfirmModal(false)
                                setConfirmModalAction(null)
                            }}
                            mode="text"
                            color={theme.colors.grey}
                        />
                    </View>
                </View>
            </ModalM>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        getMessagesRequest: state.api.getMessages?.request,
        getMessagesSuccess: state.api.getMessages?.success,
        getMessagesError: state.api.getMessages?.error,

        getPageMessagesRequest: state.api.getPageMessages?.request,
        getPageMessagesSuccess: state.api.getPageMessages?.success,
        getPageMessagesError: state.api.getPageMessages?.error,

        getMarkReadRequest: state.api.getMarkRead?.request,
        getMarkReadSuccess: state.api.getMarkRead?.success,
        getMarkReadError: state.api.getMarkRead?.error,

        postMessagesRequest: state.api.postMessages?.request,
        postMessagesSuccess: state.api.postMessages?.success,
        postMessagesError: state.api.postMessages?.error,

        user: state.data.currentUser?.object,
        token: state.data.session?.object?.token,
        isTyping: state.liveMode?.isTyping,
        typingUser: state.liveMode?.typingUser,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        liveSessionId: state.liveMode?.liveSessionId,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        lastPhoto: state.camera?.lastPhoto,
        lastPhotoFormId: state.camera?.formId,

        postImagesRequest: state.api.postImage?.request,
        postImagesSuccess: state.api.postImage?.success,
        postImagesError: state.api.postImage?.error,

        postDocumentsRequest: state.api.postDocument?.request,
        postDocumentsSuccess: state.api.postDocument?.success,
        postDocumentsError: state.api.postDocument?.error,

        postAudioRequest: state.api.postAudio?.request,
        postAudioSuccess: state.api.postAudio?.success,
        postAudioError: state.api.postAudio?.error,

        getActivityFromChatRequest: state.api.getActivityFromChat?.request,
        getActivityFromChatSuccess: state.api.getActivityFromChat?.success,
        getActivityFromChatError: state.api.getActivityFromChat?.error,
        getActivityFromChatId: state.api.getActivityFromChat?.routeParams?.id,

        schoolSubjects: state.data.staticData?.school_subjects,
        isLiveModeEnabled: state.liveMode?.isLiveModeEnabled,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    clearLastPhoto,
    setNewPhoto: setLastPhoto,
    changeCount,
    changeUnreadMessageInLiveCount,
}

export default connect(mapStateToProps, mapDispatchToProps)(CommonChat)
